import { getField, updateField } from 'vuex-map-fields';
import Vue from 'vue';

import { loadScript } from '@/utils';
import config from '@/config';
import { localAxios } from '@/apis';

function getOriginalState() {
  return {
    media: {},
    mediaPath: {},
    mediaParent: {},
    isLoadingCanva: false,
    hasLoadedCanva: false,
  };
}

export default {
  namespaced: true,

  state: getOriginalState(),

  getters: {
    hasLoadedCanva: (state) => state.hasLoadedCanva,
    getField,
  },

  mutations: {
    resetState(state) {
      Object.assign(state, getOriginalState());
    },

    setMedia(state, { id, value }) {
      Vue.set(state.media, id, value);
    },

    setMediaPath(state, { id, value }) {
      Vue.set(state.mediaPath, id, value);
    },

    setMediaParent(state, { id, value }) {
      Vue.set(state.mediaParent, id, value);
    },

    addMediaItem(state, { id, item, end = true }) {
      if (end) Vue.set(state.media, id, [...state.media[id], item]);
      else Vue.set(state.media, id, [item, ...state.media[id]]);
    },

    updateMediaItem(state, { id, item }) {
      const index = state.media[id].findIndex(
        (m) => m._id.$oid === item._id.$oid,
      );
      Vue.set(state.media[id], index, item);
    },

    addMediaItems(state, { items, id }) {
      Vue.set(state.media, id, [...state.media[id], ...items]);
    },

    deleteMediaItem(state, { id, mediaId }) {
      Vue.set(
        state.media,
        id,
        state.media[id].filter((i) => i._id.$oid !== mediaId),
      );
    },

    updateField,
  },

  actions: {
    async loadCanvaJS({ commit, state }) {
      if (!state.isLoadingCanva && !state.hasLoadedCanva) {
        commit('updateField', {
          path: 'isLoadingCanva',
          value: true,
        });
        await loadScript('https://sdk.canva.com/designbutton/v2/api.js');
        const api = await window.Canva.DesignButton.initialize({
          apiKey: config.CANVA_API_KEY,
        });
        window.CanvaButtonApi = api;
        commit('updateField', {
          path: 'isLoadingCanva',
          value: false,
        });
        commit('updateField', {
          path: 'hasLoadedCanva',
          value: true,
        });
      }
    },

    async all({ commit }, { page, pageSize, parent, organization_id, id }) {
      const { data } = await localAxios.get(`/api/media/${id}/all`, {
        params: {
          category: 'canva',
          page,
          page_size: pageSize,
          parent,
          organization_id,
        },
      });

      commit('setMediaPath', {
        id,
        value: data.path,
      });
      if (page === 1) {
        commit('setMedia', {
          id,
          value: data.media,
        });
      } else {
        commit('addMediaItems', { items: data.media, id });
      }

      return data;
    },

    async create(
      { rootGetters },
      { id, filename, height, width, type, canvaId, parent, organization_id },
    ) {
      const { data } = await localAxios.post(`/api/media/${id}`, {
        category: 'canva',
        filename,
        height,
        width,
        file_type: type,
        parent,
        canva_id: canvaId,
        organization_id,
      });

      return data;
    },

    async getFilename() {
      const { data } = localAxios.get(`/api/media/filename`);
      return data;
    },

    async createFolder(
      { rootGetters },
      { id, organization_id, data: folderData },
    ) {
      const { data } = await localAxios.post(
        `/api/media/${id}/folder`,
        folderData,
        {
          params: {
            organization_id,
          },
        },
      );

      return data;
    },

    async update(
      { rootGetters },
      { id, mediaId, data: mediaData, organization_id },
    ) {
      const { data } = await localAxios.put(
        `/api/media/${id}/${mediaId}`,
        mediaData,
        {
          params: {
            organization_id,
          },
        },
      );

      return data;
    },

    async remove({ commit }, { id, mediaId, organization_id }) {
      const { data } = await localAxios.delete(`/api/media/${id}/${mediaId}`, {
        params: {
          organization_id,
        },
      });
      commit('deleteMediaItem', { id, mediaId });

      return data;
    },
  },
};
